/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Manufacturing_PartnerInputs */

const vi_pll_in_reason_from_manufacturing_partner = /** @type {(inputs: Pll_In_Reason_From_Manufacturing_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập hàng từ đối tác sản xuất`)
};

/**

* @param {Pll_In_Reason_From_Manufacturing_PartnerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_manufacturing_partner = /** @type {((inputs?: Pll_In_Reason_From_Manufacturing_PartnerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Manufacturing_PartnerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_manufacturing_partner(inputs)
});